import {
  LOGIN_USER_LOADING,
  LOGIN_USER_FAILURE,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_LOADING,
  LOGOUT_USER_FAILURE,
  LOGOUT_USER_SUCCESS,
  REFRESH_TOKEN_REQUEST,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_FAILURE,
} from "./user.action.Types";

let token = localStorage.getItem("token");
const initialState = {
  login_laoding: false,
  login_failure: false,
  addUser: false,
  authToken: token,
  register_success: false,
  isAuth: token ? true : false,
  accessToken: null,
  refreshToken: null,
};

export const userAuth = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN_USER_LOADING: {
      return {
        ...state,
        login_laoding: true,
        login_failure: false,
        isAuth: false,
      };
    }
    case LOGIN_USER_FAILURE: {
      return {
        ...state,
        login_laoding: false,
        login_failure: true,
        isAuth: false,
      };
    }
    case LOGIN_USER_SUCCESS: {
      localStorage.setItem("user", true);
      window.sessionStorage.setItem("token", payload);
      return {
        ...state,
        login_laoding: false,
        login_failure: false,
        isAuth: true,
        authToken: payload.data,
      };
    }
    case LOGOUT_USER_LOADING: {
      return { ...state };
    }
    case LOGOUT_USER_FAILURE: {
      return { ...state };
    }
    case LOGOUT_USER_SUCCESS: {
      window.sessionStorage.removeItem("token");
      return { ...state, isAuth: false };
    }
    case REFRESH_TOKEN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        accessToken: payload.newAccessToken,
        error: null,
      };
    case REFRESH_TOKEN_FAILURE:
      return { ...state, isLoading: false, error: "Token refresh failed" };
    default: {
      return { ...state };
    }
  }
};
